import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const Rearrange = ({history}) => {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState();
  const[reordered,setReordered]=useState();

  useEffect(() => {
    // Fetch data from API when component mounts
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`/api/category/course/${courseId}`);
      setItems(response.data.message.videos);
      setTitle(response.data.message.title);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return; // If dropped outside the list

    const reorderedItems = Array.from(items);
    const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, reorderedItem);

    setItems(reorderedItems);
    setReordered(reorderedItems);
  };

  const saveToDatabase = async (reorder) => {
    try {
        console.log("hello");
      console.log(reorder, items);
      let chagedOrders =await  items?.map((item,idx) => {
        console.log(item.orderId, idx)
        item.orderId = idx
        return {
              _id: item?._id,
              orderId: idx,
            }
            
      })
     
      console.log(chagedOrders)
      // Send reorderedItems to your backend to save in the database
       await axios.put(`/api/category/editVideoOrder`,chagedOrders
       ).then(response => {
        console.log('PUT request successful:', response.data);
      })
      .catch(error => {
        console.error('Error making PUT request:', error);
      });
    //   console.log("Reordered list saved to database successfully.");
    } catch (error) {
      console.error("Error saving reordered list to database:", error);
    }
    history.push(`/admin/course/${courseId}`)
  };

  let { courseId } = useParams();

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <h2>Course Title:{title}</h2>
          <button
            onClick={() => {
              saveToDatabase(reordered)
            }}
            style={{
              backgroundColor: "green",
              color: "white",
              padding: "8px 16px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Save
          </button>
        </div>
        <Droppable droppableId="list2">
          {(provided) => (
            <ol
              {...provided.droppableProps}
              ref={provided.innerRef}
            //   style={{ border: "1px solid black", padding: "auto" }}
            >
              {items?.map((item, index) => (
                <Draggable
                  key={item?._id}
                  draggableId={item?._id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        border: "1px solid gray",
                        padding: "10px",
                        marginBottom: "8px", // Adjust spacing between items if needed
                        backgroundColor: snapshot.isDragging
                          ? "lightblue"
                          : "white", // Change background color when dragging
                        ...provided.draggableProps.style, // Required for proper dragging behavior
                      }}
                    >
                      {item?.title}
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ol>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default Rearrange;
